import React from 'react'
import styles from '../search.module.css'
export default function CustomeAlertBox({ message, onClose }) {
    return (
        <div className={styles.overlay}>
            <div className={styles.alertBox}>
                <p>{message}</p>
                <button className={styles.closeButton} onClick={onClose}>
                    Ok
                </button>
            </div>
        </div>
    );
};